import {
  isValidationError,
  rtkErrIsValidationError,
} from "@/shared/lib/errors/validation-error";

/*
 * fieldErrors is a helper to parse an RTK query error to an array that can be
 * passed to a shadcn FieldErrors.
 */
export function fieldErrors(
  error: unknown,
  field: string,
): Array<{ message?: string } | undefined> {
  if (!error) {
    return [];
  }

  let validationError = null;
  if (rtkErrIsValidationError(error)) {
    validationError = error.data;
  } else if (isValidationError(error)) {
    validationError = error;
  }

  if (!validationError) return [];

  // Filter / find error by prefix
  const fieldErrs = Object.entries(validationError.errors)
    .filter(([k]) => k.startsWith(field))
    .map(([, v]) => v)
    .pop();
  if (!fieldErrs || fieldErrs.length === 0) {
    return [];
  }

  return fieldErrs.map((message) => ({ message }));
}
